import { useCallback, useEffect, useState } from "react"

export const useDebugShortcut = () => {
  const [isOpen, setIsOpen] = useState(false)

  const handleKeyDown = useCallback(e => {
    const isShortcut = e.shiftKey && (e.metaKey || e.ctrlKey) && e.code === "KeyD"
    if (isShortcut) {
      e.preventDefault()
      setIsOpen(prev => !prev)
    }
  }, [])

  useEffect(() => {
    window.addEventListener("keydown", handleKeyDown)
    return () => window.removeEventListener("keydown", handleKeyDown)
  }, [handleKeyDown])

  return [isOpen, setIsOpen]
}
